import { useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import DocsSidebar from '../../components/DocsSidebar'
import OnThisPage from '../../components/OnThisPage'

const PLAYER_NAV = `# [Q-Play Player](/software/player-software)

## Player Software
- [General information](/software/player-software)
- [Requirements](/software/player-software/requirements)

## Supported Platforms
- [Overview](/software/player-software/supported-platforms)
- [Windows](/software/player-software/supported-platforms/windows)
- [Linux](/software/player-software/supported-platforms/linux)
- [Samsung (Tizen)](/software/player-software/supported-platforms/samsung-tizen)
- [LG (WebOS)](/software/player-software/supported-platforms/lg-webos)
`

export default function PlayerSoftware() {
  const location = useLocation()
  const proseRef = useRef<HTMLDivElement>(null)

  return (
    <section className="section api-doc-page">
      <div className="docs-layout">
        <aside className="docs-sidebar">
          <div className="docs-sidebar-inner">
            <DocsSidebar markdown={PLAYER_NAV} />
          </div>
        </aside>
        <div className="docs-content" ref={proseRef}>
          <Outlet/>
        </div>
        <OnThisPage containerRef={proseRef} watch={location.pathname}/>
      </div>
    </section>
  )
}
